var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 0.75H2.8125C1.25856 0.75 0 2.01637 0 3.5625V20.4375C0 21.9928 1.26781 23.25 2.8125 23.25H29.1875C30.7284 23.25 32 21.9981 32 20.4375V3.5625C32 2.01912 30.7464 0.75 29.1875 0.75ZM28.7936 2.625C28.219 3.19656 18.3302 13.0333 17.9888 13.3729C17.4575 13.9042 16.7512 14.1967 16 14.1967C15.2487 14.1967 14.5425 13.9041 14.0095 13.3712C13.7799 13.1427 4.00019 3.41462 3.20637 2.625H28.7936ZM1.875 20.0559V3.94531L9.97738 12.005L1.875 20.0559ZM3.20756 21.375L11.3068 13.3273L12.6854 14.6987C13.5708 15.5841 14.7479 16.0717 16 16.0717C17.2521 16.0717 18.4292 15.5841 19.3128 14.7005L20.6933 13.3273L28.7924 21.375H3.20756ZM30.125 20.0559L22.0226 12.005L30.125 3.94531V20.0559Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.a56d94ace60fbfaa1a5a01c8d299aaff.svg";
export { ForwardRef as ReactComponent };